import UserFilter from "@/model/interfaces/user/UserFilter"

export default class UserFilterService {
  static normalizeSearchFilter(search: string, filter: UserFilter): void {
    filter.email = search
    filter.username = search
    const intValue = parseInt(search)
    if (!isNaN(intValue)) {
      filter["templateSubmissions.id"] = intValue
    }
  }

  static normalizeFilters(filter: UserFilter): UserFilter {
    const normalizedFilter: UserFilter = {}

    if (filter.search) {
      this.normalizeSearchFilter(filter.search, normalizedFilter)
    }

    if (filter.pagination === false) {
      normalizedFilter.pagination = "false"
    }

    return normalizedFilter
  }
}
